import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles.css';
import { App } from './app/App';
import { registerServiceWorker } from './app/pwa';

window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason as { name?: string; message?: string } | null;
  if (
    reason?.name === 'AbortError' &&
    typeof reason.message === 'string' &&
    reason.message.includes('Transition was skipped')
  )
    event.preventDefault();
});

const container = document.getElementById('root');
if (!container) throw new Error('root element missing');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

registerServiceWorker();
